export default "__VITE_PUBLIC_ASSET__8b771a0e__"